
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/im-author",
      function () {
        return require("private-next-pages/im-author/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/im-author"])
      });
    }
  